<template>
  <div>
    <Head title="Dashboard"></Head>
    <div class="container-sm my-4">
      <h1>Bienvenido/a, {{ name }}</h1>
      <div class="my-4 row g-3">
        <div v-for="(card, key) in cards" :key="key" class="col-12 col-md-4 col-md-3">
          <link-card
            :subtitle="card.subtitle"
            :title="card.title"
            :icon="card.icon"
            :url="card.url"
          ></link-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue'
import LayoutEmpresas from '@/Layouts/LayoutEmpresas.vue'
import TextInput from '@/Components/Form/TextInput'
import LinkCard from '@/Components/LinkCard'

export default {
  name: 'Dashboard',
  layout: LayoutEmpresas,
  components: { Head, TextInput, LinkCard },
  props: {},
  data() {
    return {
      cards: [
        {
          subtitle: 'Ver',
          title: 'Ofertas publicadas',
          icon: 'bi bi-journals',
          url: this.$route('company.ofertas.index'),
        },
        {
          subtitle: 'Crear',
          title: 'Nueva oferta',
          icon: 'bi bi-journal-plus',
          url: this.$route('company.ofertas.create'),
        },
        {
          subtitle: 'Ver',
          title: 'Perfil de la empresa',
          icon: 'bi bi-briefcase',
          url: this.$route('company.profile'),
        },
        {
          subtitle: 'Editar',
          title: 'Perfil de la empresa',
          icon: 'bi bi-pencil',
          url: this.$route('company.profile.edit'),
        },
        // {
        //   subtitle: 'Descargar',
        //   title: 'Postulantes de ofertas',
        //   icon: 'bi bi-file-earmark-arrow-down-fill',
        //   url: this.$route('company.download.show'),
        // },
      ],
    }
  },
  computed: {
    name() {
      return this.$page.props.auth.profile.fullname.split(' ')[0]
    },
  },
}
</script>

<style scoped>
.card-gradient {
  background: linear-gradient(90deg, #f8ff00 0%, #3ad59f 100%);
}
</style>
